import { render } from "./AppNoteEditor.vue?vue&type=template&id=5311ac9a&scoped=true"
import script from "./AppNoteEditor.vue?vue&type=script&lang=js"
export * from "./AppNoteEditor.vue?vue&type=script&lang=js"

import "./AppNoteEditor.vue?vue&type=style&index=0&id=5311ac9a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5311ac9a"]])

export default __exports__